import React from "react";

export default function StatTile({ icon: Icon, label, value, testid, tone = "default", onClick, hint }) {
  const iconClass = tone === "warn"
    ? "h-3 w-3 text-rose-500"
    : "h-3 w-3";
  const valueClass = tone === "warn" && Number(value) > 0
    ? "mt-1 text-2xl sm:text-3xl font-bold tabular-nums text-rose-600 font-display"
    : "mt-1 text-2xl sm:text-3xl font-bold tabular-nums text-slate-900 font-display";
  const clickable = typeof onClick === "function";
  const handleKey = (e) => {
    if (!clickable) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(e);
    }
  };
  return (
    <div
      className={
        "rounded-lg border border-slate-200 bg-white p-3 sm:p-4 transition-colors " +
        (clickable
          ? "cursor-pointer hover:border-rose-300 hover:bg-rose-50/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-300"
          : "")
      }
      data-testid={testid}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? handleKey : undefined}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      title={clickable ? (hint || undefined) : undefined}
      aria-label={clickable ? (hint || label) : undefined}
    >
      <div className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-slate-500 font-medium">
        <Icon className={iconClass} />
        {label}
      </div>
      <div className={valueClass}>
        {value}
      </div>
    </div>
  );
}
